export const issueCategoryTableConfig = [
  {
    field: 'slNo',
    header: 'SI. No',
    filter: false,
    visible: true,
    defaultPinned: true,
    sortable: false,
    order: 1,
    menuItems: [],
  },
  {
    field: 'issueCategory',
    header: 'Issue Category',
    className: 'issue-category-list-data-column',
    headerClassName: 'issue-category-list-data-column',
    width: 180,
    filter: false,
    visible: true,
    defaultPinned: false,
    sortable: false,
    order: 2,
    menuItems: [],
  },
  {
    field: 'status',
    header: 'Status',
    className: 'issue-category-list-data-column',
    headerClassName: 'issue-category-list-data-column',
    width: 180,
    filter: false,
    visible: true,
    defaultPinned: false,
    sortable: false,
    order: 3,
    menuItems: [],
  },
  {
    field: 'action',
    header: 'Action',
    className: 'issue-category-list-data-column issue-category-list-action-column',
    headerClassName: 'issue-category-list-data-column issue-category-list-action-column',
    width: 180,
    exportable: false,
    filter: false,
    visible: true,
    defaultPinned: false,
    sortable: false,
    order: 5,
    menuItems: [],
  },
];
